// sensei-app/client/widgets/NotesShortcutWidget.widget.js
export default {
    name: "NotesShortcutWidget",
    type: "HtmlWidget",
    description: "A quick shortcut to the student's notes.",
    roles: ["student"],
    widget: {
        title: "Quick Access",
        size: "small", // Use a smaller size for this one
        html: `
            <a href="/student/notes" class="text-decoration-none d-flex flex-column align-items-center justify-content-center h-100 p-3 bg-primary-subtle rounded-3 text-primary-emphasis shadow-sm quick-access-widget">
                <i class="bi bi-journal-richtext display-4"></i>
                <h6 class="mt-2 mb-0">My Notes</h6>
            </a>
            <style>
                .quick-access-widget { transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out; }
                .quick-access-widget:hover { transform: translateY(-5px); box-shadow: var(--bs-box-shadow-lg) !important; }
            </style>
        `
    }
};